import axios from "axios";
import call from "@/globals/VarGlobals"

const headers = () => {
    return {
        'Content-Type': 'application/json',
        'language-iso': 'es',
        'token': call.token
    }
}

export default class HttpsUtils {
    async get(url) {
        try {
            const response = await axios.get(`${call.serverSrc}${url}`, { headers: headers() })
            return response.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async getOther(url) {
        try {
            const response = await axios.get(`${url}`)
            return response.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async post(url, body) {
        try {
            const response = await axios.post(`${call.serverSrc}${url}`, body, { headers: headers() })
            return response.data
        } catch (error) {
            console.error(error)
            return null 
        }
    }

    async put(url, body) {
        try {
            const response = await axios.put(`${call.serverSrc}${url}`, body, { headers: headers() })
            return response.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async delete(url) {
        try {
            const response = await axios.delete(`${call.serverSrc}${url}`, { headers: headers() })
            return response.data
        } catch (error) {
            console.error(error)
            return null
        }
    }
}